import classes from './GetAyobaCard.module.scss';
import Badge from '../../atoms/badge/Badge';
import DownloadLink from '../../atoms/appDownloadLink/AppDownloadLink';

export default function GetAyobaCard(props) {
    const { device, card_title } = props;

    return (
        <div className={`${classes.oCardCol} oAppLinkCard col-12 col-md-6`}>
            <div className={classes.oCard}>
                <div className={classes.mCardBody}>
                    <div className={classes.mBadges}>
                        <Badge text={card_title} theme="grey" width="fixed" />
                    </div>
                    <span className={`${classes.aTitle} fnt30f fnt-sb fontRTL`}>{device.name}</span>
                    <p className={`${classes.aText} fnt16f fontRTL`}>{device.temp_image}</p>
                </div>
                <div className={classes.mCardFooter}>
                    <div className={classes.oLinksBlock}>
                        <div className={`mStoreLinkAndroid mStoreLinkIOS`}>
                            <DownloadLink device={device} width={`151`} height={`46`} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
